import React, { useEffect, useState } from 'react';
import GroupDetail from '../../../components/Protocols/Groups/GroupDetail';
import { getPatientsInGroupAPI } from '../../../api/protocolGroups';
import { useGroups, useGroupPractitioners, useGroupPatients, useGroupPatientsPractitioner } from '../Groups/useGroups';
import { HandleError } from '../../../components/Notifications/APIErrorHandler';
import { Success } from '../../../components/Notifications/Notifications';
import { useTranslation } from "react-i18next";
import { ModalConfirm } from '../../../components/Modals/ModalConfirm';
import { ModalReassignPatients } from '../Groups/ModalReassignPatients'
import EditGroup from '../../../components/Protocols/Groups/ModalEditGroup.jsx';
import DeleteAllUsers from '../../../components/Protocols/Groups/DeleteAllUsers.jsx';
import DeleteAllPatients from '../../../components/Protocols/Groups/DeleteAllUsers.jsx';
import AddPractitioners from '../../../components/Protocols/Groups/AddPractitioners.jsx';
import DeletePractitioner from '../../../components/Protocols/Groups/DeletePractitioner.jsx';
import DeletePatient from '../../../components/Protocols/Groups/DeletePatient.jsx';

const GroupDetailContainer = ({ group, onBack, updateGroup, protocolId }) => {

    const [dataPractitioner, queryPractitioner, totalSizePractitioner, isPractitionerLoading, addPractitioners, removePractitioner, handleTableChangePractitioner, handleFilterChangePractitioner, removeAllPractitioners] = useGroupPractitioners(group?.id);
    const [dataPatient, queryPatient, totalSizePatient, isPatientLoading, addPatients, removePatient, handleTableChangePatient, addPatientToPractitioner, handleFilterChange, removeAllPatients] = useGroupPatients(group?.id, protocolId);
    const [dataPatientPractitioner, queryPatientPractitioner, totalSizePatientPractitioner, isPatientPractitionerLoading, handleTableChangePatientPractitioner, updatePatientsPractitioner, handleQueryReset, reasignPatients, handleFilterChangePatientPractitioner] = useGroupPatientsPractitioner(group?.id, protocolId);
    const [, , editGroup] = useGroups();
    
    const { t } = useTranslation();
    const [modal, setModal] = useState(null);

    const [modalPatientsLoading, setModalPatientsLoading] = useState(true);
    const [currentPractitionerAssignments, setCurrentPractitionerAssignments] = useState([null]);

    const [auxList, setAuxList] = useState([]);

    const [currentPractitionerIdForAssignment, setCurrentPractitionerIdForAssignment] = useState(null);

    const [selectedPatient, setSelectedPatient] = useState([]);
    const [selectedPractitioner, setSelectedPractitioner] = useState([]);

    const [allPractitionersAssignments, setAllPractitionersAssignments] = useState([]);
    const [allPatientsUserAssignments, setAllPatientsUserAssignments] = useState([]);

    //#region Assigment

    useEffect(() => {

        if (currentPractitionerIdForAssignment) {

            setModalPatientsLoading(true);

            const initialAssignmentsForCurrentPractitioner = (group.groupsPatientsPractitioners || [])
                .filter(assignment => assignment.practitionerId === currentPractitionerIdForAssignment)
                .map(assignment => ({
                    groupId: assignment.groupId,
                    patientId: assignment.patientId,
                    practitionerId: assignment.practitionerId,
                }));

            setCurrentPractitionerAssignments(initialAssignmentsForCurrentPractitioner)
            //copio la lista antes de que seleccione "Todos" porque sino despues cuando desselecciona todos, pierde las asignaciones
            //que ya tenia
            setAuxList(initialAssignmentsForCurrentPractitioner) // sin esta lista perdia los pacientes que ye estaban asignados en un principio

            setModalPatientsLoading(false)
        }

    }, [currentPractitionerIdForAssignment]);


    useEffect(() => {
        // Para ver cuantos pacientes tiene asignado cada usuario
        if (!group.groupsPatientsPractitioners) {
            setAllPractitionersAssignments([]);
            setAllPatientsUserAssignments([]);
            return;
        }

        // Lógica para contar pacientes por usuario
        const practitionersMap = group.groupsPatientsPractitioners.reduce((acc, assignment) => {
            const { practitionerId } = assignment;
            if (acc[practitionerId]) {
                acc[practitionerId].count += 1;
            } else {
                acc[practitionerId] = {
                    practitionerId: practitionerId,
                    count: 1
                };
            }
            return acc;
        }, {});

        // Lógica para contar usuarios por paciente
        const patientsMap = group.groupsPatientsPractitioners.reduce((acc, assignment) => {
            const { patientId } = assignment;

            if (acc[patientId]) {
                acc[patientId].count += 1;
            } else {
                acc[patientId] = {
                    patientId: patientId,
                    count: 1
                };
            }
            return acc;
        }, {});


        const practitionersList = Object.values(practitionersMap);
        const patientsList = Object.values(patientsMap);

        setAllPractitionersAssignments(practitionersList);
        setAllPatientsUserAssignments(patientsList);

    }, [group]);

    const handleAssignPatientsClick = (practitionerId) => {
        setCurrentPractitionerIdForAssignment(practitionerId);
    };

    const toggleAssignPatientsModal = () => {
        setCurrentPractitionerIdForAssignment(null);
        setAuxList([])
    };

    const handlePatientCheckboxChange = (patientMedicalRecordNumber, isChecked) => {

        setCurrentPractitionerAssignments(prevAssignments => {
            if (isChecked) {
                const alreadyExists = prevAssignments.some(
                    (assignment) =>
                        assignment.patientId === patientMedicalRecordNumber &&
                        assignment.practitionerId === currentPractitionerIdForAssignment
                );

                if (!alreadyExists) {
                    // Si NO existe, añade la nueva relación.
                    return [
                        ...prevAssignments,
                        {
                            groupId: group.id,
                            patientId: String(patientMedicalRecordNumber),
                            practitionerId: currentPractitionerIdForAssignment,
                        },
                    ];
                } else {
                    return prevAssignments;
                }
            } else {
                return prevAssignments.filter(
                    (assignment) =>
                        !(
                            assignment.patientId === patientMedicalRecordNumber &&
                            assignment.practitionerId === currentPractitionerIdForAssignment // Filtra solo la relación con este profesional
                        )
                );
            }
        });
    };


    const handleSelectAllPatients = (isChecked) => {
        setCurrentPractitionerAssignments(prevAssignments => {
            if (isChecked) {
                const assignedPatientIds = prevAssignments
                    .filter(assignment => assignment.practitionerId === currentPractitionerIdForAssignment)
                    .map(assignment => assignment.patientId);

                let newAssignments = [...prevAssignments];

                dataPatientPractitioner.forEach(patient => {
                    const patientId = patient.medicalRecordNumber;

                    if (!assignedPatientIds.includes(String(patientId))) {
                        const newAssignment = {
                            groupId: group.id,
                            patientId: String(patientId),
                            practitionerId: currentPractitionerIdForAssignment,
                        };

                        newAssignments.push(newAssignment);
                    }
                });

                return newAssignments;
            }
            else {
                setCurrentPractitionerAssignments(auxList)
                return auxList
            }
        });
    }

    const handleConfirmAssignPatients = async () => {
        setModalPatientsLoading(true);

        updatePatientsPractitioner(currentPractitionerIdForAssignment, currentPractitionerAssignments)
            .then(() => {
                updateGroup();
                Success(t('protocols.groups.patientsSuccessfullyUpdated'))
            })
            .catch(err => {
                console.error("Error actualizando pacientes:", err);
                console.log(err.response.data)

                if (err?.response?.data?.Message) {
                    HandleError(err.response.data.Message);
                } else {
                    HandleError("Error al actualizar pacientes");
                }
            });

        toggleAssignPatientsModal();
        setModalPatientsLoading(false);
    };

    const handleClosee = () => {
        setModalPatientsLoading(true)
        handleQueryReset()
        toggleAssignPatientsModal()
    }

    const patientsPractitionerProp = {
        dataPatientPractitioner,
        queryPatientPractitioner,
        totalSizePatientPractitioner,
        handleTableChangePatientPractitioner,
        modalPatientsLoading,
        currentPractitionerAssignments,
        handlePatientCheckboxChange,
        handleClosee,
        handleConfirmAssignPatients,
        currentPractitionerIdForAssignment,
        handleFilterChangePatientPractitioner,
        handleSelectAllPatients,
    };
    //#endregion

    //#region Patients
    function addPatients_Handler(_fieldName, selectedValue) {

        if (!selectedValue) return;

        const lastPick = Array.isArray(selectedValue) ? selectedValue[selectedValue.length - 1] : selectedValue;
        if (!lastPick?.medicalRecordNumber) return;

        // no duplicar al mismo paciente
        const alreadyExists = (group.groupsPatients ?? []).some(
            (p) => p.patientId === lastPick.medicalRecordNumber
        );

        if (alreadyExists) {
            HandleError(t('protocols.groups.patientExistGroup'))
            return;
        }

        //sino agrega pacientes aunque ya esten cargados en la lista
        setSelectedPatient((prevHistory) => {
            return [...prevHistory, lastPick.medicalRecordNumber];
        });

    }

    function confirmPatient() {
    
        if (!selectedPatient) {
            return;
        }

        addPatients(selectedPatient)
            .then(() => {
                updateGroup();
                Success(t('protocols.groups.patientAddedGroup'))
            })
            .catch(err => {
                console.error("Error agregando practitioner:", err);
            });
    }

    const patientsProp = {
        dataPatient,
        queryPatient,
        totalSizePatient,
        isPatientLoading,
        handleTableChangePatient,
        addPatients_Handler,
        handleFilterChange,
        selectedPatient,
        confirmPatient,
        allPatientsUserAssignments,
    };
    //#endregion

    //#region Practitioners
    function addPractitioners_Handler(_fieldName, selectedValue) {
        if (!selectedValue) return;

        const lastSelected = Array.isArray(selectedValue) ? selectedValue[selectedValue.length - 1] : selectedValue;
        if (!lastSelected?.userId) return;

        const alreadyExists = (group.groupsPractitioners ?? []).some(
            (p) => p.practitionerId === lastSelected.userId
        );

        if (alreadyExists) {
            HandleError(t('protocols.groups.practitionerExistGroup'))
            return;
        }

        //sino agrega profesionales aunque ya esten cargados en la lista
        setSelectedPractitioner((prevHistory) => {
            return [...prevHistory, lastSelected.userId];
        });

    }

    function confirmPractitioner() {

        if (!selectedPractitioner || selectedPractitioner.length === 0) {
            return;
        }
        addPractitioners(selectedPractitioner)
            .then(() => {
                updateGroup();
                Success(t('protocols.groups.practitionerAddedGroup'))
            })
            .catch(err => {
                console.error("Error agregando practitioner:", err);
            });
    }

    const deletePractitioner_Handler = (practitionerId) => {

        if (!practitionerId) return;

        const alreadyExists = (group.groupsPractitioners ?? []).some(
            (p) => p.practitionerId === practitionerId
        );

        if (!alreadyExists) {
            return;
        }

        setModal(
            <ModalConfirm
                onCancel={() => setModal(null)}
                onConfirm={async () => {

                    setModal(null);
                    // verificar si tiene pacientes asignados
                    const patientsAssignedToThisPractitioner = group.groupsPatientsPractitioners.filter(
                        (assignment) => assignment.practitionerId === practitionerId
                    );

                    if (patientsAssignedToThisPractitioner.length > 0) {
                        // Si tiene pacientes asignados, preguntar sobre la reasignación
                        showReassignPatientsModal(practitionerId, patientsAssignedToThisPractitioner.map(p => p.patientId));
                    } else {
                        // Si no tiene pacientes, proceder directamente a la eliminación
                        removePractitioner(practitionerId) // la API anterior que directamente elimina el profesional de la tabla 
                            .then(() => {
                                updateGroup();
                                Success(t('protocols.groups.practitionerDeletedGroup'));
                            })
                            .catch(err => {
                                HandleError(err.response?.data || "Error al eliminar el profesional.");
                            });
                    }
                }}
                title={t('protocols.groups.practitionerDeleteGroupConfirmation')}
            />
        );
    }

    const showReassignPatientsModal = (oldPractitionerId, assignedPatientIds) => {
        // Filtrar la lista de profesionales para excluir al que se está eliminando
        const otherPractitionersInGroup = group.groupsPractitioners.filter(
            (p) => p.practitionerId !== oldPractitionerId
        );

        setModal(
            <ModalReassignPatients
                onCancel={() => setModal(null)}
                onConfirmReassign={(newPractitionerId) => {
                    setModal(null);
                    reasignPatients(oldPractitionerId, newPractitionerId, assignedPatientIds)
                        .then(() => {
                            updateGroup();
                            Success("reasignacion exitosa")
                        })
                        .catch(err => {
                            console.error("Error al reasignar pacientes:", err);
                            console.log(err.response.data)

                            if (err?.response?.data?.Message) {
                                HandleError(err.response.data.Message);
                            } else {
                                HandleError("Error al reasignar pacientes.");
                            }
                        });
                }}
                practitioners={otherPractitionersInGroup}
                assignedPatientCount={assignedPatientIds.length}
                title={t('protocols.groups.reasignPatients')}
                description={t('protocols.groups.reasignPatientsDesc')}
            />
        );
    };

    const deleteAllPractitioners_Handler = () => {
        setModal(
            <ModalConfirm
                onCancel={() => setModal(null)}
                onConfirm={async () => {
                    try {
                        setModal(null);
                        await removeAllPractitioners();
                        updateGroup();
                        Success(t('protocols.groups.practitionerDeletedGroup'))
                    } catch (err) {
                        console.error("Error borrando usuarios:", err);
                    }
                }}
                title={t('protocols.groups.practitionersDeleteAllConfirmation')}
                description={t('protocols.groups.practitionersAllDescription')}
            />
        );
    }


    const practitionersProp = {
        dataPractitioner,
        queryPractitioner,
        totalSizePractitioner,
        isPractitionerLoading,
        handleTableChangePractitioner,
        addPractitioners_Handler,
        deletePractitioner_Handler,
        handleAssignPatientsClick,
        modalPatientsLoading,
        selectedPatient,
        confirmPractitioner,
        handleFilterChangePractitioner,
        deleteAllPractitioners_Handler,
        allPractitionersAssignments,
    };
    //#endregion

    return (
        <>
            <GroupDetail
                onBack={onBack}
                patientsProp={patientsProp}
                practitionersProp={practitionersProp}
                patientsPractitionerProp={patientsPractitionerProp}
                group={group}
            />
            {modal}
        </>

    );
};

export default GroupDetailContainer;